import { useMutation } from "@tanstack/react-query";
import { isAllBusiness, useRootAPI } from "@/api";
import { customToast } from "@/utils/customToast";

export function useOnboardFoodicsAccounts() {
  const api = useRootAPI();

  return useMutation({
    mutationFn: async (args: {
      businessId: string;
      accountIds: string[];
      userIsDemo?: boolean;
    }) => {
      if (args.userIsDemo) {
        return;
      }

      if (isAllBusiness(args.businessId)) {
        throw new Error("cannot onboard users to business in ALL BUSINESSES context");
      }
      await api.postOnboardUsersToBusiness({
        business_id: args.businessId,
        OnboardFoodicsUsersRequest: {
          ext_ids: args.accountIds,
        },
      });
    },
    onSuccess: () => {
      customToast("Login instructions sent by email", "success", "bottom");
    },
  });
}
